import { FC } from 'react';

import { Text, View } from '@react-pdf/renderer';

import { SimReportMetricType, StorageType } from '@/constants/index';
import { SimulationResult } from '@/types/simulations';

import { styles } from './styles';

interface MetricRowProps {
  label: string;
  value: unknown;
  formatMetricValue: (value: unknown) => string;
}

const MetricRow: FC<MetricRowProps> = ({ label, value, formatMetricValue }) => (
  <View style={styles.metricRow}>
    <View style={styles.metricLabelCell}>
      <Text style={styles.text}>{label}</Text>
    </View>
    <View style={styles.metricValueCell}>
      <Text style={styles.text}>{formatMetricValue(value)}</Text>
    </View>
  </View>
);

interface MetricSectionProps {
  type: SimReportMetricType;
  bestSimulation: SimulationResult;
  formatMetricValue: (value: unknown) => string;
}

const METRIC_LABELS: Record<
  SimReportMetricType,
  Record<StorageType, string>
> = {
  [SimReportMetricType.IRR]: {
    [StorageType.BEFORE_STORAGE]: 'IRR - Before Storage:',
    [StorageType.AFTER_STORAGE]: 'IRR - After Storage:',
    [StorageType.STORAGE]: 'IRR - Storage:',
  },
  [SimReportMetricType.EBITDA]: {
    [StorageType.BEFORE_STORAGE]: 'EBITDA - Before Storage:',
    [StorageType.AFTER_STORAGE]: 'EBITDA - After Storage:',
    [StorageType.STORAGE]: 'EBITDA - Storage:',
  },
};

const METRIC_VALUES: Record<
  SimReportMetricType,
  Record<StorageType, keyof SimulationResult['result']>
> = {
  [SimReportMetricType.IRR]: {
    [StorageType.BEFORE_STORAGE]: 'irrValueWos',
    [StorageType.AFTER_STORAGE]: 'irrValue',
    [StorageType.STORAGE]: 'irrBattery',
  },
  [SimReportMetricType.EBITDA]: {
    [StorageType.BEFORE_STORAGE]: 'ebitdaMarginWos',
    [StorageType.AFTER_STORAGE]: 'ebitdaMargin',
    [StorageType.STORAGE]: 'ebitdaMarginStorage',
  },
};

const MetricSection: FC<MetricSectionProps> = ({
  type,
  bestSimulation,
  formatMetricValue,
}) => {
  const labels = METRIC_LABELS[type];
  const values = METRIC_VALUES[type];

  return (
    <>
      {Object.values(StorageType).map((storageType) => (
        <MetricRow
          key={storageType}
          label={labels[storageType]}
          value={bestSimulation.result[values[storageType]]}
          formatMetricValue={formatMetricValue}
        />
      ))}
    </>
  );
};

export default MetricSection;
